/**
 * UnifiedBankAccount source types. Mirrors the backend constants in
 * `App\Modules\Treasury\App\Constants\BankAccountSourceTypes` — keep the string values in sync.
 */
export enum BankAccountSourceType {
    EXTERNAL_ACCOUNT = 'external_account',
    FINANCIAL_CONNECTIONS = 'financial_connections',
    /**
     * SD-9078: linked by typing routing and account numbers, after Stripe's Financial Connections
     * modal returned no linked account. Carries a real PaymentMethod, so it can move money from the
     * moment it is created — but it has NO Financial Connections link, so Stripe will never report a
     * balance or import transactions for it. Both halves of that matter to the UI: it belongs in the
     * transfer pickers, and it can never show a bank balance (SD-8671).
     */
    MANUAL = 'manual',
}

/**
 * Source types whose DELETION the last-connected guard protects (a Stripe external account or a
 * Financial Connections account). Since SD-9919 this list no longer defines what counts as a
 * connected ALTERNATIVE — that is judged by the core-sent isTransferEligible/isOutboundEligible
 * flags — except as the older-core fallback in the settings guard.
 */
export const CONNECTED_BANK_ACCOUNT_SOURCE_TYPES: readonly BankAccountSourceType[] = [
    BankAccountSourceType.EXTERNAL_ACCOUNT,
    BankAccountSourceType.FINANCIAL_CONNECTIONS,
];
